import { render, staticRenderFns } from "./CustomDropBoxGridTemplate.vue?vue&type=template&id=56a0d2cc&"
import script from "./CustomDropBoxGridTemplate.vue?vue&type=script&lang=js&"
export * from "./CustomDropBoxGridTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports